import { authorizationReceivingComponent } from './authorizationReceiving.component';

export const authorizationReceivingStateName = 'app.ticket.authorizationReceiving';

export const authorizationReceivingState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: authorizationReceivingStateName,
    url: '/authorizationReceiving',
    component: authorizationReceivingComponent.name,
    data: { requiresAuth: true }
  });
};
